class PreProcessedDocument {
  constructor({
    id = '',
    fileName = '',
    template = '',
    createdAt = '',
    supplier = '',
    pid = '',
    model = '',
  }) {
    this.id = id;
    this.fileName = fileName;
    this.template = template;
    this.createdAt = createdAt;
    this.supplier = supplier;
    this.model = model;
    this.pid = pid;
  }
}

export default PreProcessedDocument;
